export const mergeMessages = (current, incoming) => {
  const messages = new Map(current.map(item => [item.id, item]));
  incoming.forEach(item => messages.set(item.id, item));
  return [...messages.values()].sort((a, b) => a.id - b.id);
};

export const parseMemberIds = value => {
  const pieces = String(value || '').trim().split(/[\s,，]+/).filter(Boolean);
  if (!pieces.length || pieces.some(piece => !/^[1-9]\d*$/.test(piece) || !Number.isSafeInteger(Number(piece)))) {
    throw new Error('请输入有效的用户 UID，用逗号或空格分隔');
  }
  const ids = [...new Set(pieces.map(Number))];
  if (ids.length > 100) throw new Error('一次最多选择 100 位成员');
  return ids;
};

export const conversationPartner = (room, userId) => room.kind === 'private' && userId != null
  ? room.members?.find(member => member.user?.id != null && String(member.user.id) !== String(userId))?.user
  : undefined;

export const conversationTitle = (room, userId) => room.kind === 'private'
  ? conversationPartner(room, userId)?.nickname || conversationPartner(room, userId)?.username || '私聊'
  : room.title || (room.post ? '帖子群聊' : '群聊');
